import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../../types/types';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    segmentTrackAction
} from '../../../../../../../../../middlewares/segment';
import { SegmentCardSourceValue } from '../../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onClickEdit = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.CUSTOM_PROPERTIES_EDIT_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardSourceValue.BOARD_SETTINGS,
        }));
    };
    return action;
};
